export default function( placeData ) {
	if ( !placeData ) {
		return;
	}

	const formattedData = {};
	const componentTypeMap = {
		street_number: "short_name",
		route: "long_name",
		locality: "long_name",
		administrative_area_level_1: "long_name",
		country: "long_name",
		postal_code: "short_name"
	};

	if ( placeData.address_components ) {

		// Get each component of the address from the place details
		placeData.address_components.forEach( component => {
			const addressType = component.types[0];

			if ( componentTypeMap[addressType] ) {
				const val = component[componentTypeMap[addressType]];

				formattedData[addressType] = val;
			}
		} );

		formattedData.name = [
			[ "street_number", `${formattedData.street_number} ` ],
			[ "route", `${formattedData.route}, ` ],
			[ "locality", `${formattedData.locality}, ` ],
			[ "administrative_area_level_1", `${formattedData.administrative_area_level_1} ` ],
			[ "postal_code", `${formattedData.postal_code}` ]
		]
		.reduce( ( result, keyStringMap ) => {
			if ( formattedData.hasOwnProperty( keyStringMap[0] ) ) {
				result.push( keyStringMap[1] );
			}

			return result;
		}, [] )
		.join( "" );
	}

	if ( placeData.geometry ) {
		formattedData.latitude = placeData.geometry.location.lat();
		formattedData.longitude = placeData.geometry.location.lng();
	}

	formattedData.place_id = placeData.place_id;

	return formattedData;
}
